import React, { ImgHTMLAttributes } from 'react';
import './Image.scss';
import placeholder from '../../images/placeholder.svg';

type ImageSource = {
  src?: string;
  breakpoint: 'default' | '720px' | '960px' | '1120px' | '1360px' | '1440px';
}

interface IProps extends ImgHTMLAttributes<HTMLImageElement> {
  sources?: ImageSource[];
  width?: string | number;
  height?: string | number;
  className?: string;
}

export const Image = ({src = placeholder, sources, alt, loading = 'lazy', width = 100, height = 100, ...rest  }: IProps): React.JSX.Element => {
  if (sources) {
    const defaultSrc: string | undefined = sources.find(obj => obj.breakpoint === 'default')?.src || src;
    return (
      <picture>
        {
          sources.map((obj,i) => (
            obj.breakpoint === 'default' ? null : <source key={`img-${i}`} media={`(min-width: ${obj.breakpoint})`} srcSet={obj.src} />
          ))
        }
        <img
          src={defaultSrc}
          alt={alt}
          title={alt}
          aria-label={alt}
          width={width}
          height={height}
          loading={loading}
          {...rest}
        />
      </picture>
    )
  } else {
    return (
      <img
        src={src}
        alt={alt}
        title={alt}
        aria-label={alt}
        width={width}
        height={height}
        loading={loading}
        {...rest}
      />
    )
  }
  
};